import { ComponentProps } from "react";

export default (props: ComponentProps<any>) => {
    return (
        <svg
            viewBox="0 0 2880 340"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M 0 0 c 720 240 2880 340 2880 340 H 0 V 0 h 720"
                fill={props.fill}
            />
        </svg>
    );
}
